export default function Footer() {
    return (
        <footer className="mt-5 pt-4 pb-3" style={{ borderTop: '1px solid #dee2e6' }}>
        <div className="container">
          
          <div className="row mt-3">
            <div className="col-12 text-center">
              <p className="small">&copy; 2024 DNI Seguro. Todos los derechos reservados.</p>
            </div>
          </div>
        </div>
      </footer>
    );
}